import {SltQuery} from 'Src/models/slt';

export function sltRoute(pathname: string) {
  if (pathname === '/slt/overview' || pathname === '/slt' || pathname === '/slt/') return {view: 'overview', groupKey: undefined, studentId: undefined};
  if (pathname === '/slt/access') return {view: 'access', groupKey: undefined, studentId: undefined};
  const match = pathname.match(/^\/slt\/participation(?:\/groups\/(\d{1,2}|unknown))?(?:\/students(?:\/([a-f\d]{24}))?)?\/?$/i);
  if (!match) return {view: 'missing', groupKey: undefined, studentId: undefined};
  return {view: match[2] ? 'student' : pathname.indexOf('/students') !== -1 ? 'students' : 'participation', groupKey: match[1], studentId: match[2]};
}
export function sltQuery(search: string): SltQuery {
  const params = new URLSearchParams(search);
  const status = params.get('status');
  return {
    from: params.get('from') || undefined, to: params.get('to') || undefined,
    snapshotId: params.get('snapshotId') || undefined,
    status: status === 'none' || status === 'participating' ? status : 'all',
    page: /^\d{1,6}$/.test(params.get('page') || '') ? Math.max(1, Number(params.get('page'))) : 1,
    limit: 20,
    population: params.get('population') === 'archive' ? 'archive' : params.get('population') === 'historical' ? 'historical' : 'current',
    archiveAt: params.get('population') === 'archive' ? params.get('archiveAt') || undefined : undefined
  };
}
export function sltSearch(search: string, changes: {[key: string]: string | number | null | undefined} = {}) {
  const params = new URLSearchParams(search);
  const allowed = ['from', 'to', 'snapshotId', 'status', 'page', 'factPage', 'period', 'population', 'archiveAt', 'compare', 'compareFrom', 'compareTo'];
  const keys: string[] = [];
  params.forEach((value, key) => keys.push(key));
  keys.forEach(key => { if (allowed.indexOf(key) === -1) params.delete(key); });
  Object.keys(changes).forEach(key => {
    if (changes[key] == null) params.delete(key);
    else if (allowed.indexOf(key) !== -1) params.set(key, String(changes[key]));
  });
  return params.toString() ? `?${params.toString()}` : '';
}
export const sltPopulationLabel = (population: string) => population === 'archive' ? 'Archived roster cohort' : population === 'historical' ? 'Verified historical enrolment' : 'Current student population';
